import { useState } from "react";

import {
  AtsIntegration,
  GreenhouseIntegrationContext,
} from "./GreenhouseIntegrationContext";
import { GreenhouseSetupStep } from "./components/steps/GreenhouseSetupStep";

function generateGreenhouseApiKey() {
  return crypto.randomUUID();
}

export function GreenhouseIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    api_key: generateGreenhouseApiKey(),
    customer_group_id: "",
    report_url_type: "DIRECT_PDF_URL",
    require_authorised_user: true,
  });

  return (
    <GreenhouseIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
      }}
    >
      <GreenhouseSetupStep />
    </GreenhouseIntegrationContext.Provider>
  );
}
